import React, { ReactNode } from "react";
import { BoxTitle } from "./boxTitle.style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import classNames from "classnames";
import { Button } from "antd";
import FaIcon from "../FaIcon";
import { faChevronUp, faChevronDown } from "@fortawesome/pro-light-svg-icons";

export default (props: {
  title?: React.ReactNode;
  subtitle?: string;
  icon?: IconProp;
  inner?: boolean;
  plain?: boolean;
  middle?: boolean;
  underline?: boolean;
  extra?: ReactNode;
  toggleOpen?: () => void;
  open?: boolean;
  expandable?: boolean;
}) => (
  <div
    className={classNames(
      "w-full flex content-center flex-col justify-evenly text-[var(--primary)] cursor-pointer [&_svg]:!text-[var(--primary)]",
      { "rounded-none": props.inner }
    )}
    onClick={() => props?.toggleOpen?.()}
  >
    {!props.plain && props.middle && <div className="border-b border-[#ebebeb]" />}

    <div
      className={classNames("pt-[var(--gap-medium)] flex items-center justify-between", {
        "pb-[var(--gap)]": props.expandable,
      })}
    >
      <div className={"flex flex-row"}>
        {props.icon && <FontAwesomeIcon className="ml-5 text-[var(--primary)]" icon={props.icon} size={"lg"} />}

        {props.title ? <BoxTitle className="isoBoxTitle"> {props.title} </BoxTitle> : ""}
      </div>

      {props.expandable && (
        <div className="mr-[var(--gap)]">
          {props.open && <Button icon={<FaIcon icon={faChevronUp} size={"lg"} />} type={"link"}></Button>}
          {!props.open && <Button icon={<FaIcon icon={faChevronDown} size={"lg"} />} type={"link"}></Button>}
        </div>
      )}
    </div>
  </div>
);
